import React from "react";
import { supportLink, supportMessage } from "../utils/support";
import { useOwnezzyContact } from "../utils/branding";
import WhatsAppIcon from "./WhatsAppIcon";

// Floating "chat with support" button, bottom right on every admin page
export default function WhatsAppSupport({ user }) {
    const contact = useOwnezzyContact();
    return (
        <a className="whatsapp-support" href={supportLink(supportMessage(user), contact.whatsapp)} target="_blank" rel="noreferrer" aria-label="Chat with Ownezzy support on WhatsApp">
            <WhatsAppIcon size={26} />
            <span>Need help?</span>
        </a>
    );
}
